module.exports = __webpack_public_path__ + "static/media/color_blind_image_1.798fdbdb.jpg";